<style>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button{
	    -webkit-appearance: none !important;
	    margin: 0; 
	}
	input[type="number"]{-moz-appearance:textfield;}
</style>
<template>
	<!-- 文字类型的 -->
	<div class="form-horizontal">
	  	<div class="form-group  has-feedback" 
	  		:class="{'has-success' : status == 1,'has-error' : status == -1}">
		    <div class="{{class}}">
		      	<input type="{{type}}" class="form-control" placeholder="{{title}}"
		      		v-model="value"
		    		@blur="blur" 
    				@input="input" maxlength="{{maxlength}}">
		      	<span class="glyphicon glyphicon-ok form-control-feedback" v-if="status == 1"></span>
				<span class="glyphicon glyphicon-remove form-control-feedback" v-if="status == -1"></span>
		    </div>
	    	<label class="control-label c-danger tl"  v-if="status == -1 && tips == true">{{errorTxt}}</label>
	    	<slot></slot>
	  	</div>
	</div>
</template>
<script>
	var Common = require('../../utils/Common.js');
	/**
	* 当前VM对象的相关操作
	*/
	var VM = {
		/**
		 * 验证 
		 * comp 当前组件对象
		 * @param  validate1,validate2 验证函数
		 */
		childver: function(comp,validate1,validate2) {
			var errorTxt = "请输入正确的" + comp.title;
			if(!comp.must) {//非必填如果输入内容为空则不验证，不为空就验证
				if(!comp.value) {//为空情况
					comp.isOK = true;
					comp.isActivated = false;//非必填无需激活状态
				} else {//非空情况					
					if(validate1 || validate2) {
						VM.numberRange(comp);
					} else {
						comp.isOK = false;
						comp.errorTxt = errorTxt;
					}
				}
			} else {//必填情况需验证	
				if(!comp.value) {//为空验证
					comp.isOK = false;
					comp.errorTxt = '请输入' + comp.title;
				} else {//非空验证
					if(validate1 || validate2) {
						VM.numberRange(comp);
					} else {
						comp.isOK = false;
						comp.errorTxt = errorTxt;
					}
				}				
			}
		},		 
		 
		/***
		* 验证的操作
		* @param comp 当前组件对象
		*/
		ver : function(comp){
			var childver = function() {
				if(Common.isMaxLen(comp.value,comp.max)){//输入内容超过最大值
					comp.isOK = false;
					comp.errorTxt = comp.title + '不要超过' + comp.max + '个字';
				}
				if(!comp.value) {//输入内容为空时
					comp.isOK = false;
					comp.errorTxt = '请输入' + comp.title;
				} else {
					if(Common.isMinLen(comp.value,comp.min)) {
						comp.isOK = false;
						comp.errorTxt = comp.title + '不少于' + comp.min + '个字';
					} else if(!Common.isMaxLen(comp.value,comp.max) && !Common.isMinLen(comp.value,comp.min)) {
						comp.isOK = true;//验证通过
					}
				}
			}
			if(!comp.must) {//如果非必填
				if(!comp.value) {
					comp.isOK = true;
					comp.isActivated = false;//非必填无需激活状态
				} else {
					childver();
				}
			} else{
				childver();
			}
		},
		/**
		 * 数字类型的大小判断 （错误信息判断时还有点问题，稍后解决，比如：类型是number时，输入11.111.1，value就置空了）
		 */
		numberRange: function(comp) {	
			var value = comp.value;
			var min = comp.minnum;
			var max = comp.maxnum;
			var compare = function() {
				if(value < min) {
					comp.errorTxt = comp.title + '不小于' + comp.minnum;
					comp.isOK = false;
				} 
				if(value > max) {
					comp.errorTxt = comp.title + '不大于' + comp.maxnum;
					comp.isOK = false;
				}
				if(value >= min && value <= max) {
					comp.isOK = true;
				}
			}
			if(comp.minnum == 0 && comp.maxnum == 1.7e+10) {
				comp.isOK = true;
			}
			if(comp.type == 'number' || comp.type == 'price' || comp.type == 'discount') {//当类型未浮点数时，字符串转换浮点数
				value = parseFloat(comp.value);
				min = parseFloat(comp.minnum);
				max = parseFloat(comp.maxnum);
				compare();			
			} else if(comp.type == 'posnumber') {//当类型为正整数时，字符串转换整数
				value = parseInt(comp.value);
				min = parseInt(comp.minnum);
				max = parseInt(comp.maxnum);
				compare();
			}		
		},
		/**
		* 电话号码||手机号码的验证
		*/
		tel : function(comp){
			VM.childver(comp,Common.isTel(comp.value),Common.isPhone(comp.value));//调用上面定义的方法
		},
		/**
		* 手机号码的验证
		*/
		phone : function(comp){
			VM.childver(comp,Common.isPhone(comp.value));//调用上面定义的方法
		},
		/**
		*  价格的验证
		*/
		floatNumber : function(comp){		
			VM.childver(comp,Common.isFloat(comp.value));//调用上面定义的方法
		},
		/**
		 * 折扣值的验证
		 */
		discount : function(comp){		
			VM.childver(comp,Common.isDiscount(comp.value));//调用上面定义的方法
		},
		/**
		 * 正整数验证 可以为0
		 */
		posNumber: function(comp) {
			VM.childver(comp,Common.isPositiveInt(comp.value));//调用上面定义的方法
		},
		/**
		 * 工商执照号
		 */
		businessLicense: function(comp) {
			VM.childver(comp,Common.isBusLicense(comp.value));//调用上面定义的方法
		},
		/**
		 * 特殊字符过滤
		 */
		stripscript: function(comp) {
			VM.childver(comp,Common.isSpecialstr(comp.value));//调用上面定义的方法
		},
		normalName: function(comp) {
			VM.childver(comp,Common.isNormalstr(comp.value));//调用上面定义的方法
		},
		/**
		* 车牌号，不含地域
		*/
		carnumber : function(comp){
			VM.childver(comp,Common.isCarNum(comp.value));
		},
		/**
		 * 非负整数
		 */
		nonnegativeInt: function(comp) {
			VM.childver(comp,Common.isNonnegativeInt(comp.value));
		},
		/**
		 * 固定长度
		 */
		fixString: function(comp) {
			VM.childver(comp,Common.isFixString(comp.value,comp.length));
		},
		/*
		 *商品条码验证
		 */
		isProductCode: function(comp) {
			VM.childver(comp,Common.isProductCode(comp.value));
		},
		/**
		* 初始化的类型判断
		*/
		initType : function(comp){
			//判断，输入框类型
			switch(comp.type){
				case 'name' : 
					comp.verFunc = this.stripscript;
					break;
				case 'normalname' : //名称(中文、字母和数字)
					comp.verFunc = this.normalName;
					break;
				case 'tel' : //电话号码(包括座机和手机)
					comp.type = 'tel';
					comp.verFunc =  this.tel;
					break;
				case 'phone' ://手机号码
					comp.type = 'tel';
					comp.verFunc =  this.phone;					
					break;
				case 'password'://密码输入框
					comp.type = 'password';
					comp.verFunc =  this.ver;
					break;
				case 'price' : 
					comp.type = 'price';//价格
					comp.verFunc = this.floatNumber;
					break;
				case 'number' : 
					comp.type = 'number';//工时
					comp.verFunc = this.floatNumber;
					break;
				case 'posnumber' : 
					comp.verFunc = this.posNumber;//正整数的验证
					break;
				case 'license': 
					comp.verFunc = this.businessLicense;//正整数的验证
					break;
				case 'discount': 
					comp.verFunc = this.discount;//折扣的验证
					break;
				case 'carnumber': //车牌号
					comp.verFunc = this.carnumber;
					break;
				case 'nonnegativeInt': //非负数
					comp.verFunc = this.nonnegativeInt;
					break;
				case 'fixstring': //固定长度字符
					comp.verFunc = this.fixString;
					break;
				case 'productcode': //商品条码
					comp.verFunc = this.isProductCode;
					break;
				default:
					comp.type = 'text';
					comp.verFunc =  this.ver;
					break;
			}
		}
	};
	/**
		@param type 输入框的类型
		@param value 关联输入的内容 .sync
		@param title 输入的标题 
		@param min 不少于多少个字 默认为0
		@param max 不多于多少个字 默认为25
		@param must 标识是否是必填项 默认为true
		@param tips 标识是否显示提示文字错误
		@param class 输入框的样式 默认 col-sm-8
		@param minnum 标识输入值最小的值
		@param maxnum 标识输入值最大的值
		@param length 固定长度
	*/
	module.exports = {
		props : ['type','value','title','min','max','must','tips','class','maxlength','minnum','maxnum','length'],
		data : function(){
			return {
				isOK : false, //标识验证是否通过		
				verFunc : null,//记录用于验证的函数
				isActivated : false,//标识是否激活了判断
				errorTxt : '',//错误的提示文字
				/**
				* 验证是否通过验证
				*/
				isAdopt : function(){
					this.isActivated = true;//激活判断
					this.verFunc(this);
					return this.isOK;
				}
			}
		},
		ready : function(){
			if(this.type == undefined){
				this.type = 'text';
			}		
			if(this.min == undefined){
				this.min = 0;
			}
			if(this.max == undefined){
				this.max = 80;
			}
			if(this.must == undefined || this.must == 'true'){
				this.must = true;
			} else {
				this.must = false;//非必填
			}
			if(this.tips == undefined){
				this.tips = true;
			}
			if(this.class == undefined){
				this.class = 'col-sm-8';
			}
			if(this.minnum == undefined){
				this.minnum = 0;
			}
			if(this.maxnum == undefined) {
				this.maxnum = 1.7e+10;
			}
			if(this.length == undefined) {
				this.length = 100;
			}
			//VM初始化的处理
			VM.initType(this);
		},
		computed : {
			/**
			* 输入框的状态 -1:错误状态，0:正常状态,1正确状态
			*/
			status : function(){
				var num = 0;
				if(this.isActivated){
					num = this.isOK ? 1 : -1; 
				}
				return num;
			}
		},
		methods : {
			/**
			* 失去焦点
			*/
			blur : function(){
				if(!this.isActivated){
					this.isActivated = true;//激活判断
				}
				//验证的判断
				this.verFunc(this);
			},
			/**
			* 输入的监听
			*/
			input : function(){
				//移除两边的空格，并过滤特殊字符
				// this.name = Common.stripscript(Common.trim(this.value));
				if(!this.isActivated){
					this.isActivated = true;//激活判断
				}
				//非正常状态，进入输入验证
				// if(this.status != 0){
					this.verFunc(this);
				// }
			}
		}
	};
</script>


/** WEBPACK FOOTER **
 ** text.vue?32d90632
 **/